// extracted by mini-css-extract-plugin
var _1 = "Embed-module__container--Oe8eA";
var _2 = "Embed-module__isDocumentLike--FklKy";
export { _1 as "container", _2 as "isDocumentLike" }
